import useFetch from './fetch';

export default function useGetKeys() {
  const fetch = useFetch();
  return (languageTag, status) => { return fetch(`/api/key/${languageTag}?status=${status}`).then(x => x.json()) };
};
